module.exports = __webpack_public_path__ + "img/logoVida.44b13ed8.png";